import { theme } from '../../Assets/Styles/theme'

const styles = {
  container: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '20px',
    background: '#fff',
    border: '1px solid #E6EAEE',
    borderRadius: '4px',
    padding: '20px 40px',
  },
  table: {
    width: '90%',
    overflow: 'hidden',
    maxHeight: '100px',
    tableLayout: 'fixed',
  },
  tableHead: {
    fontSize: '14px',
    color: theme.colors.silver3,
    border: 'none',
  },
  tableCell: {
    border: 'none',
    minWidth: '33%',
    padding: '4px',
    minHeight: '40px',
  },
  titleContainer: {
    width: '7%',
    marginRight: '20px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '18px',
    color: '#011533',
  },
}

export default styles
